const firebaseConfig = {
  apiKey: "AIzaSyBBKvixDXMT-WzKzGp2UD9-doL6hYMjBhg",
  authDomain: "dental-clinic-e79bb.firebaseapp.com",
  projectId: "dental-clinic-e79bb",
  storageBucket: "dental-clinic-e79bb.appspot.com",
  messagingSenderId: "367980743040",
  appId: "1:367980743040:web:43de15839de3c800185965",
};

export default firebaseConfig;
